import styled from "styled-components";

const FormSection = styled.div`
    margin-bottom: 1em;
`;

export default FormSection;
